export default __webpack_public_path__ + "static/media/9.66384503.jpg";